import React, { FC, useState } from 'react';
import ResetPasswordIcon from '../../../../assets/images/svg/ResetPassowordIcon';
import {
  CardContainer,
  CardIconHeader,
} from '../../../../shared/components/card';
import { TextInput } from '../../../../shared/components/inputs';
import { Button } from '../../../../shared/components/button';
import { NavigationLink } from '../../../../shared/components/utility';
import { ResetRequest } from '../../infra/types/RequestPasswordReset.type';
import { useAppSelector } from '../../../../shared/infra/redux';

interface ResetRequestTemplateProps {
  onSubmit: (resetRequest: ResetRequest) => Promise<void>;
}

const ResetRequestTemplate: FC<ResetRequestTemplateProps> = ({ onSubmit }) => {
  const isLoading = useAppSelector(
    (state) => state.public.requestResetStatus.status,
  );
  const initialValue: ResetRequest = { email: '' };
  const [resetRequest, setResetRequest] = useState<ResetRequest>(initialValue);

  const handleOnSubmit = async () => {
    await onSubmit(resetRequest);
  };

  const handleOnInputChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = evt.target;
    setResetRequest({ ...resetRequest, [name]: value.toLowerCase() });
  };

  return (
    <CardContainer
      className='my-8 w-full rounded-lg bg-white shadow lg:my-0 xl:my-0'
      header={
        <CardIconHeader
          headerHeight='AUTO'
          icon={<ResetPasswordIcon />}
          title='Reset Your Password'
          subtitle='Enter your email address to recieve a link to reset your password'
        />
      }
    >
      <form>
        <TextInput
          classes={['mb-10']}
          label='Email'
          placeholder='Email Address'
          name='email'
          onChange={handleOnInputChange}
        />
        <Button
          classes={['mb-10']}
          label='Request Password Reset'
          theme='PRIMARY'
          type='button'
          isLoading={isLoading === 'loading'}
          onClick={handleOnSubmit}
        />
      </form>
      <div className='mb-4 flex flex-row items-center justify-center'>
        <NavigationLink dest='/' label='Back to login' color='gray' />
      </div>
    </CardContainer>
  );
};

export default ResetRequestTemplate;
